import React ,{useState} from 'react'
import './CSS/LoginSignup.css'
const Loginsignup = () => {


const[state,setState]=useState("Login");
const [formData,SetFormData]=useState(
{
username:"",
password:"",
email:""
})




const changeHandler=(e)=>{
  SetFormData({...formData,[e.target.name]:e.target.value})
}











const login=async()=>{
  console.log("login",formData);

  let responseData;
  try{
    const resp = await fetch('https://sarathi-0cyh.onrender.com/login',{
      method:'POST',
      headers:{
        'Accept':'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify(formData),
    });
    if(!resp.ok) throw new Error(resp.statusText);
    responseData = await resp.json();
  }catch(err){
    console.error('Login request failed:', err);
    alert('Network error during login. Please try again.');
    return;
  }

  if(responseData.success){
    localStorage.setItem('auth-token',responseData.token);
    window.location.replace("/");
  }
  else{
    alert (responseData.errors);
  }

}


const signup=async()=>{
  console.log("Signup",formData);

  let responseData;
  try{
    const resp = await fetch('https://sarathi-0cyh.onrender.com/signup',{
      method:'POST',
      headers:{
        'Accept':'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify(formData),
    });
    if(!resp.ok) throw new Error(resp.statusText);
    responseData = await resp.json();
  }catch(err){
    console.error('Signup request failed:', err);
    alert('Network error during signup. Please try again.');
    return;
  }

  if(responseData.success){
    localStorage.setItem('auth-token',responseData.token);
    window.location.replace("/");
  }
  else{
    alert (responseData.errors);
  }
}











  return (
    <div className='loginsignup'>
      <div className="loginsignup-container">
        <h1>{state}</h1>
        <div className="loginsignup-fields">
         {state==="Sign Up"?<input name='username' value={formData.username} onChange={changeHandler} type="text" placeholder='Your Name' />:<></>}
          <input type="email" name='email'value={formData.email} onChange={changeHandler} placeholder='Email Address' />
          <input name='password' value={formData.password} onChange={changeHandler} type="password" placeholder='Password' />
        </div>
        <button onClick={()=>{state==="Login"?login():signup()}}>Continue</button>


{state==="Sign Up"?<p className="loginsignup-login">
          Already have an account <span onClick={()=>{setState("Login")}}>Login Here</span>
        </p>:<p className="loginsignup-login">
          Create an account <span onClick={()=>{setState("Sign Up")}}>Click Here</span>
        </p>}

        


        



        {/* <div className="loginsignup-agree">
          <input type="checkbox" name='' id='' />
          <p>By Continuing ,I agree to the terms of use & privacy policy. </p>
        </div> */}
      </div>
    </div>
  )
}

export default Loginsignup
